import Modal from './Modal'

const DeletingModal = () => {
    return (
        <Modal onClose={() => { }} maxWidth="max-w-sm" isBackgroundTransparent={true}>
            <div className="px-4 flex flex-col items-center justify-center py-8">
                <div className="mb-4 animate-pulse">
                    <svg className="animate-spin h-10 w-10 text-red-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8  0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                    </svg>
                </div>
                <h2 className="text-xl font-semibold mb-2 text-red-600">กำลังลบรูปภาพ...</h2>
                <p className="text-lg text-gray-700">โปรดรอสักครู่</p>
            </div>
        </Modal>
    )
}

export default DeletingModal;